module.exports = __webpack_public_path__ + "media/images/es_419/performance_index_continuum-d03a243c4bb4b5d2ad9d98e5e32184e6.png";